/* ===========================================================
   키즈다 뉴스 — 데이터 모델 (원본 시드 데이터)
   원본 오프라인 프로토타입 데이터 스토어를 정적 모듈로 이식
   =========================================================== */

/* 카테고리 개편(2026-08): 웹은 1차(뉴스 주제, 네이버 표준 6종)만 노출 (BR-09).
   이 목록은 newsCategoryTopicList API 실패 시 메뉴 폴백 전용 —
   key 가 실제 topicCategorySeq 와 다르므로 폴백 상태에선 카테고리 필터가
   '전체'처럼 동작한다 (기존 폴백과 동일한 한계). */
export const CORNERS = [
    { key: "society",  name: "사회",      color: "#5F3AD1", desc: "우리 사회의 오늘을 읽어요" },
    { key: "culture",  name: "생활/문화", color: "#FF7520", desc: "일상과 문화 속 이야기" },
    { key: "science",  name: "IT/과학",   color: "#0693DA", desc: "미래를 바꾸는 기술과 과학" },
    { key: "economy",  name: "경제",      color: "#07A66E", desc: "용돈으로 배우는 경제 상식" },
    { key: "world",    name: "세계",      color: "#F03F71", desc: "지구촌 곳곳의 소식" },
    { key: "politics", name: "정치",      color: "#0D6CF9", desc: "민주주의와 우리 삶" },
  ];

export const cornerOf = (k) => CORNERS.find((c) => c.key === k) || CORNERS[0];
export const topicOf = cornerOf;

export const STATUS = {
  pending: { key: "pending", label: "승인대기", color: "#E08309", bg: "#FFF4E2" },
  approved: { key: "approved", label: "승인", color: "#137a4a", bg: "#E5F6EC" },
  rejected: { key: "rejected", label: "반려", color: "#C0392B", bg: "#FCE9E7" },
};

export const seedArticles = [
    /* ── 깊이 읽기 ── */
    { id:"a01", corner:"deep", title:"한국, 피지컬 AI 산업의 새로운 무대로!",
      summary:"로봇에 인공지능을 더한 '피지컬 AI'가 전 세계의 주목을 받고 있어요. 한국이 그 중심 무대에 섰답니다.",
      author:"키즈다 편집부", date:"2026-06-09", views:6120, pick:true, headline:true, status:"approved",
      tags:["젠슨 황","피지컬AI","AI"], hue:250 },
    { id:"a02", corner:"deep", title:"11년 간 화성 과거 추적한 메이븐, 굿바이!",
      summary:"11년 동안 화성의 대기를 살펴 온 탐사선 '메이븐'이 긴 임무를 마치고 작별 인사를 전했어요.",
      author:"키즈다 편집부", date:"2026-06-08", views:4210, pick:false, headline:false, status:"approved",
      tags:["메이븐","탐사선","화성"], hue:244 },
    { id:"a03", corner:"deep", title:"6월 8일자 NIE 융합형 논술",
      summary:"신문으로 공부하는 융합형 논술. 오늘의 주제로 생각의 폭을 넓혀 봐요.",
      author:"키즈다 편집부", date:"2026-06-08", views:1880, pick:false, headline:false, status:"approved",
      tags:["신문 속 교과서","NIE","초등 논술"], hue:256 },
    { id:"a04", corner:"deep", title:"다리가 20개! '성게' 닮은 로봇 등장",
      summary:"성게를 닮은 다리 20개짜리 로봇이 나왔어요. 울퉁불퉁한 길도 척척 걸어간답니다.",
      author:"키즈다 편집부", date:"2026-06-05", views:3990, pick:true, headline:false, status:"approved",
      tags:["성게","로봇","다리"], hue:238 },

    /* ── 한입 뉴스 ── */
    { id:"a05", corner:"onebite", title:"비 안 오는 날도 장마철? '장마' 뜻 새롭게 정의!",
      summary:"기상청이 '장마'의 뜻을 새롭게 정리했어요. 비가 오지 않아도 장마철일 수 있대요.",
      author:"키즈다 편집부", date:"2026-06-09", views:5230, pick:true, headline:false, status:"approved",
      tags:["장마","비","장마철"], hue:12 },
    { id:"a06", corner:"onebite", title:"비행기 모는 로봇 '파이봇', 세계가 주목!",
      summary:"사람처럼 비행기를 조종하는 로봇 '파이봇'이 등장했어요. 전 세계가 깜짝 놀랐답니다.",
      author:"키즈다 편집부", date:"2026-06-09", views:4760, pick:true, headline:false, status:"approved",
      tags:["파이봇","조종사 로봇","조종"], hue:18 },
    { id:"a07", corner:"onebite", title:"캐러멜색 믹스견, '캐러멜로'를 아시나요?",
      summary:"길에서 만난 캐러멜색 강아지 이야기. 사랑스러운 믹스견의 매력을 알아봐요.",
      author:"키즈다 편집부", date:"2026-06-08", views:3120, pick:false, headline:false, status:"approved",
      tags:["캐러멜로","캐러멜","믹스견"], hue:22 },
    { id:"a08", corner:"onebite", title:"AI, 전기만 쓰는 줄 알았더니 쓰레기도 만드네?",
      summary:"인공지능을 많이 쓸수록 전자 쓰레기도 늘어난대요. 환경을 위해 함께 생각해 볼 문제예요.",
      author:"키즈다 편집부", date:"2026-06-08", views:2980, pick:false, headline:false, status:"approved",
      tags:["AI","전자폐기물","환경"], hue:6 },

    /* ── 영어 뉴스 ── */
    { id:"a09", corner:"english", title:"안세영, 올해만 다섯 번째 정상!",
      summary:"배드민턴 국가대표 안세영 선수가 올해만 다섯 번째 우승을 차지했어요. 영어 뉴스로 함께 읽어봐요.",
      author:"Kidsda English Desk", date:"2026-06-09", views:3540, pick:false, headline:false, status:"approved",
      tags:["안세영"], hue:150 },
    { id:"a10", corner:"english", title:"이정후, 또 한 경기 4개 안타!",
      summary:"메이저리그에서 활약 중인 이정후 선수가 한 경기에서 4안타를 쳤어요. 대단하죠?",
      author:"Kidsda English Desk", date:"2026-06-08", views:3010, pick:false, headline:false, status:"approved",
      tags:["이정후"], hue:156 },
    { id:"a11", corner:"english", title:"6호 태풍 '장미' 강타한 일본, 세찬 비바람에 우산도 휘청",
      summary:"태풍 '장미'가 일본을 강하게 덮쳤어요. 오늘의 영어 뉴스로 세계 날씨 소식을 만나요.",
      author:"Kidsda English Desk", date:"2026-06-05", views:2240, pick:false, headline:false, status:"approved",
      tags:["장미","태풍"], hue:144 },

    /* ── 어기자GO ── */
    { id:"a12", corner:"reporter", title:"내 손으로 직접 우리 학교를 알리다",
      summary:"어린이 기자가 직접 우리 학교 홍보 영상을 만들었어요. 그 생생한 현장을 전해드려요.",
      author:"어린이기자 김도윤", date:"2026-06-09", views:2870, pick:false, headline:false, status:"approved",
      tags:["학교","홍보영상","홍보"], hue:28 },
    { id:"a13", corner:"reporter", title:"외암민속마을에서 보낸 특별한 하루",
      summary:"전통이 살아 있는 외암민속마을에서 보낸 하루. 어린이 기자가 직접 체험했어요.",
      author:"어린이기자 박서윤", date:"2026-06-09", views:2410, pick:false, headline:false, status:"approved",
      tags:["외암민속마을","야행","체험"], hue:34 },
    { id:"a14", corner:"reporter", title:"작가에게 직접 들은 동화 탄생 이야기!",
      summary:"동화 작가를 만나 책이 어떻게 만들어지는지 들었어요. 북토크 현장을 함께 가요.",
      author:"어린이기자 이하준", date:"2026-06-09", views:2050, pick:false, headline:false, status:"approved",
      tags:["동화","작가","북토크"], hue:20 },
    { id:"a15", corner:"reporter", title:"경복궁 생과방에서 즐긴 궁중 다과",
      summary:"경복궁에서 옛날 임금님이 드시던 궁중 다과를 맛봤어요. 달콤한 역사 체험이었답니다.",
      author:"어린이기자 정하린", date:"2026-06-02", views:1760, pick:false, headline:false, status:"approved",
      tags:["경복궁","생과방","궁중"], hue:40 },

    /* ── 상상발전소 ── */
    { id:"a16", corner:"imagine", title:"6월 9일자 가로세로 낱말퍼즐",
      summary:"오늘의 시사 낱말 퍼즐. 머리도 식히고 상식도 쑥쑥 키워 봐요.",
      author:"키즈다 편집부", date:"2026-06-09", views:1980, pick:false, headline:false, status:"approved",
      tags:["지식","가로세로퍼즐","어린이시사"], hue:320 },
    { id:"a17", corner:"imagine", title:"[2026 문예상 6월 후보/동시] 마음금고",
      summary:"어린이 문예상 6월 후보 동시. 마음을 차곡차곡 모아 두는 따뜻한 시예요.",
      author:"키즈다 편집부", date:"2026-06-09", views:1240, pick:false, headline:false, status:"approved",
      tags:["문예상","동시","어린이 동시"], hue:316 },
    { id:"a18", corner:"imagine", title:"[2026 문예상 6월 후보/동시] 책들의 버스정류장",
      summary:"책을 기다리는 마음을 그린 어린이 동시. 도서관이 정류장처럼 느껴져요.",
      author:"키즈다 편집부", date:"2026-06-09", views:1110, pick:false, headline:false, status:"approved",
      tags:["문예상","동시","어린이 동시"], hue:326 },
    { id:"a19", corner:"imagine", title:"[2026 문예상 6월 후보/동시] 우리의 색",
      summary:"저마다 다른 우리의 색을 노래한 동시. 모두가 특별하다는 이야기예요.",
      author:"키즈다 편집부", date:"2026-06-09", views:1030, pick:false, headline:false, status:"approved",
      tags:["문예상","동시","어린이 동시"], hue:310 },

    /* ── 어동 책방 ── */
    { id:"a20", corner:"book", title:"5교시 끝나면 이사 갈 거야!",
      summary:"전학을 앞둔 아이의 마음을 그린 그림책. 오늘의 추천 도서로 소개해요.",
      author:"키즈다 책방지기", date:"2026-06-09", views:2230, pick:true, headline:false, status:"approved",
      tags:["오늘의 책 추천","초등 도서"], hue:38 },
    { id:"a21", corner:"book", title:"분수와 소수로 떠나는 톰 소여의 모험",
      summary:"신나는 모험 이야기로 분수와 소수를 배우는 수학 동화예요.",
      author:"키즈다 책방지기", date:"2026-06-08", views:1890, pick:false, headline:false, status:"approved",
      tags:["수학동화","오늘의 책 추천"], hue:44 },
    { id:"a22", corner:"book", title:"오늘은 축제야!",
      summary:"신나는 축제 이야기로 가득한 그림책. 즐거움이 팡팡 터져요.",
      author:"키즈다 책방지기", date:"2026-06-05", views:1620, pick:false, headline:false, status:"approved",
      tags:["오늘의 책 추천","초등 도서"], hue:32 },

    /* ── 톡톡 토론 ── */
    { id:"a23", corner:"debate", title:"전용기 타고 영화제 참석하는 배우들에게 하고 싶은 말은?",
      summary:"화려한 영화제, 여러분의 생각은 어떤가요? 찬반 의견을 나눠 봐요.",
      author:"키즈다 편집부", date:"2026-06-09", views:5410, pick:true, headline:false, status:"approved",
      tags:["토론","독자참여","영화제"], hue:0 },
    { id:"a24", corner:"debate", title:"위험한 상황에 놓인 동물 구조, 내 생각은?",
      summary:"위기에 빠진 동물을 어떻게 도와야 할까요? 함께 토론해 봐요.",
      author:"키즈다 편집부", date:"2026-06-02", views:3260, pick:false, headline:false, status:"approved",
      tags:["토론","독자 참여","동물 구조"], hue:354 },
    { id:"a25", corner:"debate", title:"탈출 늑대 '늑구'를 마케팅에 활용해도 될까?",
      summary:"화제의 늑대 '늑구'를 마케팅에 써도 될까요? \"지역에 활력\" vs \"안전이 먼저\", 찬반으로 생각해 봐요.",
      author:"키즈다 편집부", date:"2026-05-27", views:2980, pick:false, headline:false, status:"approved",
      tags:["어동 찬반토론","늑구","마케팅"], hue:6 },

    /* ── 교육·입시 ── */
    { id:"a26", corner:"edu", title:"학생·학부모 \"지역의사제 의대 지원하겠다\" 60.3%",
      summary:"지역의사제 의대에 지원하겠다는 응답이 60.3%로 나타났어요. '지역 정착하겠다'도 50.8%. 무슨 제도일까요?",
      author:"키즈다 편집부", date:"2026-01-27", views:4120, pick:true, headline:false, status:"approved",
      tags:["지역의사제","의대","의대 지원"], hue:210 },
    { id:"a27", corner:"edu", title:"'사탐런' 영향? SKY 정시, 인문계열에 몰려… 전년 대비 46% 증가",
      summary:"정시에서 인문계열 지원이 크게 늘었어요. 그 배경을 차근차근 살펴봐요.",
      author:"키즈다 편집부", date:"2025-12-03", views:3380, pick:false, headline:false, status:"approved",
      tags:["2026학년도 정시","SKY대학","모의지원"], hue:204 },
    { id:"a28", corner:"edu", title:"내신 1등급은 10%뿐인데… 일반고 절반은 고1 학생 수 200명 미만",
      summary:"학교 규모와 내신 등급의 관계를 알아보는 교육 이야기. 학부모가 알아 두면 좋아요.",
      author:"키즈다 편집부", date:"2025-12-01", views:2910, pick:false, headline:false, status:"approved",
      tags:["고입","특목자사고","내신"], hue:216 },

    /* ── 경제 탐험 ── */
    { id:"a29", corner:"explore", title:"어린이 뉴스 앱 '키즈다', 신규 기능 업데이트",
      summary:"키즈다 앱이 더 똑똑하고 편리하게 바뀌었어요. 새로워진 기능을 만나 보세요.",
      author:"키즈다 편집부", date:"2026-02-11", views:2680, pick:false, headline:false, status:"approved",
      tags:["키즈다"], hue:45 },
    { id:"a30", corner:"explore", title:"용돈 기입장 쓰는 어린이가 더 똑똑하게 소비한다",
      summary:"한 달 동안 용돈 기입장을 쓴 친구들은 충동구매가 크게 줄었대요. 용돈 관리, 함께 시작해요!",
      author:"키즈다 편집부", date:"2026-02-05", views:2240, pick:false, headline:false, status:"approved",
      tags:["용돈","소비습관"], hue:50 },

    /* ── 검토 대기/반려 (Admin 데모용) ── */
    { id:"a31", corner:"reporter", title:"세계 어린이들이 함께한 '바다 청소의 날'",
      summary:"30개 나라 어린이들이 같은 날 바닷가를 청소했어요. 작은 손길이 모여 큰 변화를 만들어요.",
      author:"어린이기자 정하준", date:"2026-06-03", views:0, pick:false, headline:false, status:"pending",
      tags:["세계","환경","캠페인"], hue:30 },
    { id:"a32", corner:"book", title:"여름방학 추천 도서 30선 미리보기",
      summary:"올여름 읽기 좋은 책 30권을 골랐어요. 어동 책방이 미리 살짝 공개합니다.",
      author:"키즈다 책방지기", date:"2026-06-04", views:0, pick:false, headline:false, status:"pending",
      tags:["여름방학","추천도서"], hue:36 },
    { id:"a33", corner:"edu", title:"초등 영어, 받아쓰기 다시 도입 논란",
      summary:"초등 영어 받아쓰기 도입을 두고 의견이 갈려요. 사실관계 확인 후 보강이 필요한 기사예요.",
      author:"키즈다 편집부", date:"2026-05-30", views:0, pick:false, headline:false, status:"rejected",
      tags:["영어","받아쓰기"], hue:208 },
  ];

// 본문에 노출되는 기사 (원본 App과 동일하게 승인된 기사만)
export const approvedArticles = seedArticles.filter((a) => a.status === "approved");

/* ---- 카테고리 이름 정규화 (공백 제거 + 가운뎃점 통일) ----
   API 카테고리(categorySeq 기반)와 시드 기사(코너 키 기반)를
   "이름"으로 매칭하기 위한 헬퍼 */
export const normalizeCat = (s) =>
  (s || "").replace(/\s+/g, "").replace(/[·‧・ㆍ]/g, "·");

// 시드 카테고리 이름(정규화) → 설명(desc) 매핑 (API 카테고리 설명 보강용)
export const descByName = CORNERS.reduce((acc, c) => {
  acc[normalizeCat(c.name)] = c.desc;
  return acc;
}, {});

// 기사(시드)의 카테고리 표시명 (정규화) — 이름 매칭용
export const articleCategoryName = (a) => normalizeCat(cornerOf(a.corner).name);
